import React, { useEffect, useRef, useState } from 'react';
import * as St from './index.styled';
import { useApiInfoContextValueHook } from '../../../../contexts/ApiInfoContextProvider';
import { SellertoolSignatureUtils } from '../../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../../components/backdrop/default/v1';
import axios from 'axios';
import { customToast } from '../../../../components/toast/custom-react-toastify/v1';
import * as StTable from './styled/table.styled';
import { CustomDateUtils } from '../../../../utils/custom-date-utils';
import { Button, Menu, MenuItem } from '@mui/material';
import CustomBlockButton from '../../../../components/button/CustomBlockButton';
import { CustomDialog } from '../../../../components/dialog/v1/CustomDialog';

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export function WegetSelectBackupds(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [backupRackLocationMetas, setBackupRackLocationMetas] = useState(null);
    const [selectedBackupMeta, setSelectedBackupMeta] = useState(null);
    const [backupRackLocations, setBackupRackLocations] = useState(null);
    const [recoveryNoticeModalOpen, setRecoveryNoticeModalOpen] = useState(false);

    useEffect(() => {
        handleFetchBackupRackLocationMetas();
    }, []);

    const handleFetchBackupRackLocationMetas = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const fetchResult = await axios.get(`${API_HOST}/backup-rack-locations/metas`, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            });

        if (fetchResult?.content) {
            setBackupRackLocationMetas(fetchResult?.content);
        }

        CustomBackdropController().hideBackdrop();
    };

    const handleFetchBackupRackLocations = async (backupUUID) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        CustomBackdropController().showBackdrop();
        const fetchResult = await axios.get(`${API_HOST}/backup-rack-locations/${backupUUID}/list`, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                };
            })
            .catch(err => {
                customToast.error(err.response);
            });

        CustomBackdropController().hideBackdrop();

        if (fetchResult?.content) {
            setBackupRackLocations(fetchResult?.content);
        }
    };

    const handleSelectMeta = (meta) => {
        setSelectedBackupMeta(meta);
        handleFetchBackupRackLocations(meta.backupUUID);
    }

    const handleClickRecoveryButton = async () => {
        if (!selectedBackupMeta || !backupRackLocations) {
            customToast.error('백업 파일을 선택해주세요');
            return;
        }

        setRecoveryNoticeModalOpen(true);
    }

    const handleReqRecovery = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        CustomBackdropController().showBackdrop();
        const fetchResult = await axios.post(`${API_HOST}/backup-rack-locations/${selectedBackupMeta.backupUUID}/recovery`, {}, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                };
            })
            .catch(err => {
                customToast.error(err.response);
            });

        CustomBackdropController().hideBackdrop();

        if (fetchResult?.content) {
            customToast.success('복구가 완료되었습니다.');
            setRecoveryNoticeModalOpen(false);
        }
    }

    return (
        <>
            <St.Selection.Container>
                <St.Selection.Title>로케이션 백업 선택</St.Selection.Title>
                <CustomDropdown options={backupRackLocationMetas} onSelect={(value) => handleSelectMeta(value)} />
                {selectedBackupMeta ?
                    <div>
                        <div>{selectedBackupMeta?.backupUUID}</div>
                        <div>{CustomDateUtils().formatDateToYYYYMMDD_HHMMSSFromUnixTime(selectedBackupMeta?.backupAt)}</div>
                    </div>
                    :
                    <div>백업 파일을 선택해주세요</div>
                }
            </St.Selection.Container>
            <St.BackupButton.Container>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleClickRecoveryButton()}
                >
                    백업 복구
                </CustomBlockButton>
            </St.BackupButton.Container>
            <St.Table.Container>
                <StTable.TableContainer style={{ marginTop: '20px' }}>
                    <StTable.StyledTable>
                        <StTable.ColumnGroup>
                            <col className="col-1" />
                            <col className="col-2" />
                            <col className="col-3" />
                            <col className="col-4" />
                            <col className="col-5" />
                        </StTable.ColumnGroup>
                        <StTable.TableHeader>
                            <StTable.HeaderRow>
                                <StTable.HeaderCell>로케이션 넘버</StTable.HeaderCell>
                                <StTable.HeaderCell>로케이션 타입</StTable.HeaderCell>
                                <StTable.HeaderCell>입고 랙 사용여부</StTable.HeaderCell>
                                <StTable.HeaderCell>링크 투 로케이션</StTable.HeaderCell>
                                <StTable.HeaderCell>핸들러</StTable.HeaderCell>
                            </StTable.HeaderRow>
                            <StTable.HeaderRow>
                                <StTable.HeaderCell>상품명</StTable.HeaderCell>
                                <StTable.HeaderCell>옵션명</StTable.HeaderCell>
                                <StTable.HeaderCell>옵션코드</StTable.HeaderCell>
                                <StTable.HeaderCell>수량</StTable.HeaderCell>
                                <StTable.HeaderCell>단위</StTable.HeaderCell>
                            </StTable.HeaderRow>
                        </StTable.TableHeader>
                        <StTable.TableBody>
                            {backupRackLocations?.map((rackLocation, index) => {

                                return (
                                    <React.Fragment key={rackLocation?.uuid}>
                                        <StTable.LocationRow>
                                            <StTable.TableCell
                                                className='bold'
                                            >
                                                {rackLocation.address}
                                            </StTable.TableCell>
                                            <StTable.TableCell
                                                className='bold'
                                                style={rackLocation.type === 'NORMAL' ? { color: 'var(--greenColor1)' } : { color: 'var(--blueColor1)' }}
                                            >
                                                {rackLocation.type}
                                            </StTable.TableCell>
                                            <StTable.TableCell>
                                                <StTable.StatusBadge $status={rackLocation.enabledYn}>
                                                    {rackLocation.enabledYn === 'y' ? '사용가능' : '사용불가'}
                                                </StTable.StatusBadge>
                                            </StTable.TableCell>
                                            <StTable.TableCell
                                                className='bold'
                                            >
                                                <span style={rackLocation?.linkToLocationAddress ? { color: 'hotpink' } : {}}>{rackLocation?.linkToLocationAddress}</span>
                                            </StTable.TableCell>
                                            <StTable.TableCell>
                                            </StTable.TableCell>
                                        </StTable.LocationRow>
                                        {rackLocation.items?.map(item => {
                                            return (
                                                <StTable.ProductRow key={item?.uuid}>
                                                    <StTable.TableCell>
                                                        {item.productName}
                                                    </StTable.TableCell>
                                                    <StTable.TableCell>
                                                        {item.optionName}
                                                    </StTable.TableCell>
                                                    <StTable.TableCell>
                                                        {item.optionCode}
                                                    </StTable.TableCell>
                                                    <StTable.TableCell>
                                                        {item.productQuantity}
                                                    </StTable.TableCell>
                                                    <StTable.TableCell>
                                                        {item.boxQuantity}
                                                    </StTable.TableCell>
                                                </StTable.ProductRow>
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            })}
                        </StTable.TableBody>
                    </StTable.StyledTable>
                </StTable.TableContainer>
            </St.Table.Container>

            {recoveryNoticeModalOpen &&
                <RecoveryNoticeModal
                    open={recoveryNoticeModalOpen}
                    onClose={() => setRecoveryNoticeModalOpen(false)}
                    onConfirm={handleReqRecovery}
                />
            }
        </>
    );
}

const RecoveryNoticeModal = ({ open, onClose, onConfirm }) => {
    return (
        <CustomDialog
            open={open}
            onClose={() => onClose()}
        >
            <St.RecoveryNoticeModal.Body>
                <div className='message'>
                    <div>백업을 복구하시면 현재 사용중인 데이터가 삭제됩니다.</div>
                    <div>복구를 진행 하시겠습니까?</div>
                </div>
                <CustomBlockButton
                    type='button'
                    onClick={() => onConfirm()}
                >
                    복구
                </CustomBlockButton>
                <CustomBlockButton
                    type='button'
                    className='cancel'
                    onClick={() => onClose()}
                >
                    취소
                </CustomBlockButton>
            </St.RecoveryNoticeModal.Body>
        </CustomDialog>
    );
};

const CustomDropdown = ({ options, onSelect }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <St.CustomDropdown.Container>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                백업 선택
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {options?.map((option, index) => {
                    return (
                        <MenuItem key={option.backupUUID} onClick={() => {
                            onSelect(option);
                            handleClose();
                        }}>
                            <St.CustomDropdown.MenuItemContent>
                                <div className='uuid'>{option?.backupUUID}</div>
                                <div className='backupAt'>{CustomDateUtils().formatDateToYYYYMMDD_HHMMSSFromUnixTime(option?.backupAt)}</div>
                            </St.CustomDropdown.MenuItemContent>
                        </MenuItem>
                    );
                })}
            </Menu>
        </St.CustomDropdown.Container>
    );
};